import { DashboardContext } from 'live/context/dashboard'
import { WidgetContext } from 'live/context/widget'

import { WidgetEditorContext } from 'live/context/widget-editor'
import { useContext } from 'react'

interface DashboardContextProps {
    widgetId: number
    dashboardId: number
    editMode: boolean
    reload: (objectType: string) => void
}

const updateRules = {
    trajectory: ['wbs', 'survey', 'bha'],
    mudLog: ['wbs', 'lithology', 'bha']
}

export default function useDashboard(): DashboardContextProps {
    const dashboardContext: any = useContext(DashboardContext)

    const widgetContext: any = useContext(WidgetContext)
    const editorContext: any = useContext(WidgetEditorContext)
    if (editorContext.data) {
        return {
            widgetId: editorContext.data.id,
            dashboardId: editorContext.dashboard.id,
            reload: () => editorContext.actions.testFilters(),
            editMode: true
        }
    } else {
        const reload = (objectType: string): void => {
            // the preferred object (by default) is linked. If we change a trajectory the dashboard should update all
            // widget with that component.
            // TODO: configure this as optional
            // TODO: can we impreve this looking for fields?
            if (updateRules[objectType]) {
                dashboardContext.dashboard.widgets.forEach((widget: Record<string, unknown>, widgetIndex: number) => {
                    if (updateRules[objectType].includes(widget.type)) {
                        dashboardContext.actions.stop(widgetIndex)
                        dashboardContext.actions.start(widgetIndex)
                    }
                })
            } else {
                dashboardContext.actions.stop(widgetContext.widgetIndex)
                dashboardContext.actions.start(widgetContext.widgetIndex)
            }
        }

        return {
            widgetId: widgetContext.widget?.id,
            dashboardId: widgetContext.widget?.dashboard?.id,
            reload,
            editMode: false
        }
    }
}
